import { render, staticRenderFns } from "./bigsite.vue?vue&type=template&id=051c9898&"
import script from "./bigsite.vue?vue&type=script&lang=js&"
export * from "./bigsite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports